/**
 * After support token rotation (exit impersonation, select company, etc.)
 * in-flight requests still carry the previous JWT. Those 401s must not
 * log the user out of the new session.
 */

let ignoreUntil = 0

export function suppressStaleUnauthorized(ms = 8000): void {
  ignoreUntil = Date.now() + ms
}

export function shouldIgnoreUnauthorized(requestToken?: string | null): boolean {
  const current = typeof localStorage === 'undefined' ? null : localStorage.getItem('token')
  // A 401 from the token that is still current is a real expiry — never ignore it.
  if (requestToken && current && requestToken === current) {
    return false
  }
  if (Date.now() < ignoreUntil) {
    return true
  }
  if (!requestToken) {
    return false
  }
  return !!(current && requestToken !== current)
}

/** Test-only: clear the suppress window. */
export function resetStaleUnauthorizedGuard(): void {
  ignoreUntil = 0
}
